import React from 'react'
import {Routes,Route,Navigate} from 'react-router-dom'
import Home from '../Component/Home'
import Login from '../Component/Login'
import SignIn from '../Component/SignIn'
import Steps from '../Component/Steps';
import Participate from '../Component/Participate'
import ExampleComponent from '../Component/SubComponent/AddCookie'
import PrivateRoute from '../Component/PrivateRoute'
import Register from '../Component/Register'
import Lobby from '../Component/Lobby'
import Room from '../Component/Room'
import ForgetPassword from '../Component/ForgetPassword'
import Loading from '../Component/SubComponent/Loading'
import Facebook from '../Component/Google & facebook/FacebookRegister'


function MyRoutes() {
  return (
    <Routes>

        <Route path="/" element={<Home/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/signup" element={<SignIn/>}/>
        {/* <Route path="/learnmore" element={<StepsToParticipate/>}/> */}
        
        <Route path="/participate" element={<PrivateRoute><Participate/></PrivateRoute>}/>
        <Route path="/cookie" element={<ExampleComponent/>}/>

      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignIn />} />
      <Route path="/learnmore" element={<Steps />} />
      <Route path="/participate" element={<Participate />} />
      <Route path="/Register" element={<PrivateRoute><Register /> </PrivateRoute>} />
      <Route path="/lobby" element={<PrivateRoute><Lobby /> </PrivateRoute>} />
      <Route path="/room" element={<PrivateRoute><Room /></PrivateRoute>} />
      <Route path={"/room?room"} element={<PrivateRoute><Room /></PrivateRoute>} />
      <Route path={"/forgetpassword"} element={<ForgetPassword />} />
      <Route path={"/loader"} element={<Loading />} />
      <Route path={"/fac"} element={<Facebook />} />

    </Routes>
  );
}

export default MyRoutes